const $ = jQuery.noConflict();
 
 
const langSwitch = () =>{
	let parent = $('.switch-lang-select');

	parent.map((index,data)=>{ 
		let activeLang = $(data).find('li.active');
		
		let activeLangHolder = $(data).find('.current-choice ul');
		console.log(activeLangHolder);
		$(activeLangHolder).html($(activeLang).clone()); 
	});

	 
	 $('.current-choice').on('click', (e)=>{
		 $(e.delegateTarget).toggleClass('active');
		$('.langs-holder').toggleClass('active');
	 });
	
	 $('.langs-holder').find('li').on('click', (e)=>{
		 window.location = e.delegateTarget.attributes[1].value;
	 });


	 
}
//const langS = new langSwitch('.switch-lang-select');
export default langSwitch;
